/* * @Author: 孙福聪 * @Date: 2019-01-16 16:02:47 * @Last Modified by: 孙福聪 * @Last Modified time:
2019-02-14 13:15:38 */
<template lang="pug">
.login
  .overburden
  .from
    .form-title
      img.logo(:src="logo")
      span {{ softConfig.softName }}
    .login-from
      .form-content
        p.title 登录
        Form.form(
          ref="loginForm",
          :model="loginForm",
          tatus-icon,
          :rules="formRules"
        )
          FormItem.formitem(prop="code")
            Input.input(v-model="loginForm.code", placeholder="请输入账号")
          FormItem(prop="password")
            Input(
              v-model="loginForm.password",
              placeholder="请输入密码",
              type="password",
              prop="password",
              @keyup.enter.native="submitForm('loginForm')"
            )
          FormItem
            //- Checkbox(label='记住密码' v-model='isRemember')
            //-   span 记住密码
            a.forget(@click="gopassword") 忘记密码
          FormItem
            Button(type="primary", @click="submitForm('loginForm')") 登录
          .cas
            a(style="color:lightslategray;font-weight: bolder" href="casredirect.html" v-if="softConfig.useCas==1") 使用CAS账号登录
  div
    .copyright {{ softConfig.copyRightValue }}
    .segmenting-line
    p.version v{{ version }}
</template>

<script>
import focusData from "../utils/focusData.js";
export default {
  data() {
    return {
      loginForm: {
        code: "",
        password: ""
      },
      formRules: {
        code: [
          { required: true, message: "请输入账号", trigger: "blur" },
          {
            pattern: /^[a-zA-Z0-9_-]{1,20}$/,
            message: "账号只能为字母,下划线数字,长度不能超过20位",
            trigger: "blur"
          }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            pattern: /^[a-zA-Z0-9_-]{1,16}$/,
            message: "密码只能为字母,下划线数字,长度不能超过12位",
            trigger: "blur"
          }
        ]
      },
      softConfig: "",
      version: "3.0.1",
      isRemember: false
    };
  },
  computed: {
    casePower() {
      return this.$store.state.Case.pattern;
    }
  },
  methods: {
    gopassword() {
      this.$router.replace("/forgetpassword");
    },
    getSoft() {
      this.$http.softConfig().then((res) => {
        this.softConfig = res.data;
        document.title = res.data.softName;
      });
      // this.$http.getVersion().then(res => {
      //   this.version = res.data.version;
      // });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        // console.log(valid)
        if (valid) {
          const loginData = {
            code: this.loginForm.code,
            password: this.loginForm.password
          };
          this.$http
            .login(loginData)
            .then((res) => {
              if (res.data.success) {
                // console.log(res);
                const token = {
                  role: res.data.data.role,
                  code: res.data.data.code,
                  name: res.data.data.name,
                  token: res.data.data.token,
                  type: "policy"
                };
                if (this.isRemember) {
                  window.sessionStorage.setItem("icon_isRemember", "true");
                }
                window.sessionStorage.setItem("token", JSON.stringify(token));
                sessionStorage.setItem("tokenTest", res.data.data.token);
                document.cookie = "SignInstate=true";
                sessionStorage.setItem("pageIndex", 0);
                this.$Message.success("登录成功");
                focusData.getToken();
                // getToken();
                // console.log(Vue)
                console.log(this.casePower);
                if (this.casePower.includes("policy")) {
                  if (token.role === "student") {
                    // this.$http.getClassMemberByCode({ id: loginData.code }).then(res2 => {
                    // if (res2.data.success) {
                    // sessionStorage.setItem("classId", res2.data.data.classId);
                    this.$router.replace({
                      path: "/Student/home"
                    });
                    // }
                    // });
                  } else if (token.role === "admin") {
                    this.$router.replace({
                      path: "/Teacher/userlist"
                    });
                  } else {
                    this.$router.replace({
                      path: "/Teacher/classlist"
                    });
                  }
                } else if (this.casePower.includes("analysis")) {
                  window.location.href = "/policy/analysis.html";
                }
              }
            })
            .catch((error) => {
              console.sun(error);
              this.$Message.error("登录异常");
            });
        } else {
          this.$Message.error("error submit");
          return false;
        }
      });
    }
  },
  mounted() {
    console.log(this.$store);
    this.getSoft();
  }
};
</script>
<style lang="stylus" scope>
.cas
  text-align right
  margin-top -10px
  margin-right 0px
  font-size 12px
.login
  position relative
  background url('../assets/loginpage/Group@2x.png') no-repeat center center
  background-color rgba(0, 0, 0, 0.6)
  background-size 100% 100%
  height 100vh
  width 100%
  box-sizing border-box
  z-index 1
  overflow hidden
  min-height 768px
  &:after
    content ''
    width 102vw
    height 102vh
    position absolute
    left -1vw
    top -1vh
    background inherit
    filter blur(10px)
    z-index 2
  .copyright
    color #fff
    font-size 16px
    z-index 3
    width 100%
    position absolute
    bottom 65px
    text-align center
  >.overburden
    position absolute
    top 0
    right 0
    height 100%
    width 100%
    background rgba(0, 0, 0, 0.6)
    z-index 3
  .from
    position absolute
    z-index 4
    left 50%
    top 50%
    width 100vw
    transform translate(-50%, -50%)
    >.form-title
      text-align center
      white-space nowrap
      margin-bottom 45px
      & *
        display inline-block
        vertical-align middle
      >.logo
        width 44px
        height 33px
        position relative
        top -3px
      >span
        font-size 30px
        color white
    >.login-from
      z-index 4
      position relative
      width 534px
      text-align center
      margin auto
      >.form-content
        background #fff
        border-radius 12px
        margin auto
        height 364px
        width 380px
        padding 30px 30px 0px 30px
        >.title
          text-align center
          color #2A2E36
          font-size 20px
          // margin-top 28px
          margin-bottom 20px
        .ivu-input
          display inline-block
          width 320px
          height 40px
          font-size 14px
          color black
          background-color #F4F4F4
        .ivu-checkbox-wrapper
          font-size 14px
          color #808080
          float left
        .forget
          font-size 14px
          position absolute
          right 0
          top -3px
          color #808080
          text-decoration none
        button
          display block
          width 320px
          height 40px
          font-size 16px
          margin-bottom 5px
          margin-left 0
        .segmenting-line
          height 0
          width 100%
          border-bottom 1px solid #CCCCCC
          margin-top 65px
        .copyright
          width 320px
          height 30px
          margin-bottom -20px
          line-height 30px
          font-size 14px
          text-align center
          color #808080
        p
          text-align center
          color #808080
          font-size 14px
          margin-bottom 0
          margin-top 11px
</style>
